import { ApiEndpoint } from "../enums/ApiEndpoint";
import { IUser } from "../models/IUser";

export const magicLogin = async (token: string | null): Promise<IUser> => {
  return fetch(ApiEndpoint.AUTH_MAGICLOGIN_CALLBACK + `?token=${token}`)
    .then(res => res.json());
};
